import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.register(ChartDataLabels);
window.Chart = Chart;

import pattern from "patternomaly";

const gray = "rgba(148, 148, 148, 1)";
const green = "rgba(100, 163, 58, 1)";
const orange = "rgba(238, 188, 64, 1)";
const red = "rgba(197, 65, 28, 1)";
const blue = "rgba(0, 0, 255, 1)";

window.generateDashboardChart = function (
    id,
    data,
    backgroundByFistSum = false,
    showLegend = true
) {
    const ctx = document.getElementById(id);

    new Chart(ctx, {
        type: "bar",
        plugins: [
            ChartDataLabels,
            {
                afterInit: (chart) => {
                    let ctx = chart.ctx;
                    let xAxis = chart.scales.x;
                    let yAxis = chart.scales.y;

                    let labels = chart.data.labels;
                    let $container = $('<div class="chart-labels"></div>');
                    $(chart.ctx.canvas).parent().append($container);

                    // console.log('afterInit', chart.data.datasets);

                    let i = 1;
                    chart.data.datasets.forEach((dataset, index) => {
                        //console.log(dataset);

                        if(dataset.datalabels.display == false) return;
                        if(typeof dataset.data[0].original == 'undefined') return;

                        let data = dataset.data[0].original;

                        let label = data.name;
                        if(typeof data.labelLink !== 'undefined'){
                            label = `<a href="${data.labelLink}">${label}</a>`;
                        }

                        if(typeof data.labelHtml !== 'undefined'){
                            label = data.labelHtml;
                        }

                        if(dataset.data[0].bg !== 'undefined'){
                            label = label.replace('#fff', dataset.data[0].bg);
                        }

                        if(typeof data.hasExportError !== 'undefined' && data.hasExportError){
                            label = `<i class="fas fa-exclamation-circle text-danger"></i> ${label}`;
                        }
                        $container.append(`<div class="chart-label chart-label-${i++}" style="position: absolute;">
                            <div class="chart-label-inner">${label}<div>
                            </div>`);
                    });
                },
                afterRender: (chart) => {
                    let ctx = chart.ctx;
                    let xAxis = chart.scales.x;
                    let yAxis = chart.scales.y;

                    let items = xAxis.getLabelItems();
                    let i = 1;
                    items.forEach((item, index) => {
                        // console.log(item);
                        let rotation = item.options.rotation;

                        let $label = $(chart.ctx.canvas).parent().find('.chart-label:nth-child('+(i++)+')');
                        if($label.length){
                            $label.css({
                                'left': item.options.translation[0],
                                'top': item.options.translation[1],
                                'transform': 'translate(-'+(rotation?'100':'50')+'%)',
                            });
                            $label.find('.chart-label-inner').css({
                                'transform': 'rotate('+rotation+'rad)',
                            });
                        }
                    });
                },
            },
        ],
        data: {
            datasets: generateDataSets(data, backgroundByFistSum),
        },
        options: {
            animations: false,
            scales: {
                x: {
                    stacked: true,
                    grid: {
                        display: false,
                        drawTicks: false,
                    },
                    ticks: {
                        color: 'white',
                    }
                },
                y: {
                    grace: '20%',
                    stacked: true,
                    ticks: {
                        display: false,
                        maxTicksLimit: 5,
                    },
                    border: {
                        display: false,
                    },
                },
            },
            interaction: {
                intersect: false,
                mode: 'nearest',
            },
            plugins: {
                legend: {
                    display: showLegend,
                },
                tooltip: {
                    enabled: false,
                    position: 'nearest',
                    external: externalTooltipHandler
                }
            },
        },
    });
};

function generateDataSets(data, backgroundByFistSum) {
    //console.log(data);
    let datasets = [];

    let sum = 0;

    if (backgroundByFistSum) {
        sum = data[0].value;
    }

    for (let i = 0; i < data.length; i++) {
        let element = data[i];
        let label =  element.name || element.type;

        let background = element.background || gray;

        // slozeny z hodnoceni
        if (element.hasOwnProperty("values") && element.values.hasOwnProperty('poor_count')) {
            for (const key in element.values) {
                if (Object.hasOwnProperty.call(element.values, key)) {
                    const value = element.values[key];
                   // console.log(key, value);

                    switch(key){
                        case 'poor_count': background = red; break;
                        case 'average_count': background = orange; break;
                        case 'high_count': background = green; break;
                    }

                    let full = {
                        label: label,
                        data: [{ x: label, y: value, original: element, bg: background }],
                        borderWidth: 0,
                        backgroundColor: background,
                        datalabels: {
                            display: key == 'high_count',
                            anchor: "end",
                            align: "end",
                            formatter: function (value, context) {
                                let v = element.value;
                                if (!isNaN(v)){
                                    v = window.numberFormat(v);
                                }
                                return v;
                            },
                            font: {
                                weight: "bold",
                                size: 14,
                            },
                        },
                    };
                    datasets.push(full);
                }
            }
        }else{
            // obyceny graf
            if (backgroundByFistSum && i > 0) {
                background = getBackground(
                    element.value + (element.partialValue || 0),
                    sum
                );
            }
            if (typeof element.background !== 'undefined'){
                background = element.background;
            }

            let full = {
                label: label,
                data: [{ x: label, y: element.value, original: element, bg: background }],
                borderWidth: 0,
                backgroundColor: background,
                datalabels: {
                    display:
                        (!element.hasOwnProperty("partialValue") ||
                        element.partialValue <= 0),
                    anchor: "end",
                    align: "end",
                    formatter: function (value, context) {
                        let v = element.value + (element.partialValue || 0);
                        if (!isNaN(v)){
                            v = window.numberFormat(v);
                        }
                        return v;
                    },
                    font: {
                        weight: "bold",
                        size: 14,
                    },
                },
            };
            datasets.push(full);

            // graf se srafovanim
            if (element.hasOwnProperty("partialValue")) {
                let partial = {
                    label: element.partialName,
                    data: [{x: label, y: element.partialValue, original: element, bg: background}],
                    borderWidth: 0,
                    backgroundColor: pattern.draw(
                        "diagonal-right-left",
                        background,
                        "rgb(255, 255, 255, .7)",
                        10
                    ),
                    datalabels: {
                        display: element.partialValue > 0,
                        anchor: "end",
                        align: "end",
                        formatter: function (value, context) {
                            let v = element.value + element.partialValue;
                            if (!isNaN(v)) {
                                v = window.numberFormat(v);
                            }
                            return v;
                        },
                        font: {
                            weight: "bold",
                            size: 14,
                        },
                    },
                };
                datasets.push(partial);
            }

            // if (element.hasOwnProperty("partialValue2")) {
            //     let partial2 = {
            //         label: 'ahoj', //element.partialName2,
            //         data: [{ x: label, y: element.partialValue2, original: element }],
            //         borderWidth: 0,
            //         backgroundColor: blue,
            //         datalabels: {
            //             display: element.partialValue2 > 0,
            //             anchor: "end",
            //             align: "end",
            //             formatter: function (value, context) {
            //                 let v = element.value + element.partialValue;
            //                 if (!isNaN(v)){
            //                     v = window.numberFormat(v);
            //                 }
            //                 return v;
            //             },
            //             font: {
            //                 weight: "bold",
            //                 size: 14,
            //             },
            //         },
            //     };

            //     datasets.push(partial2);
            // }
        }
    }

    // console.log(datasets);
    return datasets;
}

function getBackground(value, sum) {
    if (sum <= 0) return red;

    let p = (100 * value) / sum;

    if (p >= 80) return green;
    if (p >= 20) return orange;
    return red;
}

const getOrCreateTooltip = (chart) => {
    let tooltipEl = chart.canvas.parentNode.querySelector(".popover");

    if (!tooltipEl) {
        tooltipEl = document.querySelector(".popover-template").cloneNode(true);
        tooltipEl.classList.remove('popover-template')
        tooltipEl.style.position = "fixed";
        tooltipEl.style.opacity = 0;
        tooltipEl.style.pointerEvents = "none";
        tooltipEl.style.display = "";
        tooltipEl.style.transition = 'all .1s ease';
        // tooltipEl.style.transform = 'translate(-50%, 0)';

        chart.canvas.parentNode.appendChild(tooltipEl);
    }

    return tooltipEl;
};

var popupDataCache = {};

const externalTooltipHandler = (context) => {
    // Tooltip Element
    const { chart, tooltip } = context;
    const tooltipEl = getOrCreateTooltip(chart);


    // Hide if no tooltip
    if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }

    const tooltipData = tooltip.dataPoints[0].raw.original || {};
    // console.log(tooltipData);

    if(!tooltipData.hasOwnProperty('popup') || !tooltipData.hasOwnProperty('route') || !tooltipData.hasOwnProperty('payload')){
        tooltipEl.style.opacity = 0;
        return;
    }

    const content = tooltipEl.querySelector(".popover-content");
    content.innerHTML = "";

    let key = tooltipData.route + JSON.stringify(tooltipData.payload);

    if (popupDataCache[key]) {
        content.innerHTML = popupDataCache[key];
        tooltipEl.style.opacity = 1;
    } else {
        $.ajax({
            url: tooltipData.route,
            method: 'GET',
            data: tooltipData.payload,
            success: function (response) {
                popupDataCache[key] = response.html;
                content.innerHTML = response.html;
                setTimeout(function(){
                    tooltipEl.style.opacity = 1;
                }, 100);
            }
        })
    }

    const { left: positionX, top: positionY } = chart.canvas.getBoundingClientRect();

    tooltipEl.style.left = positionX + tooltip.caretX + "px";
    tooltipEl.style.top = positionY - 30 + tooltip.caretY + "px";
    tooltipEl.style.font = tooltip.options.bodyFont.string;
};
